module.exports = __webpack_public_path__ + "static/media/nagi_active559513456412c31f09cd9350c8bd99b5.webp";